import {
  SET_RES_ID,
  SET_DRIVER_FIRST_NAME,
  SET_DRIVER_LAST_NAME,
  SET_DRIVER_CITIZENSHIP,
  SET_DRIVER_BIRTH_DATE,
  SET_DRIVER_GENDER,
  SET_CAR_LICENCE_PLATE,
  SET_TRAILER_LICENCE_PLATE,
  SET_CARGO_LENGTH,
  SET_CARGO_WEIGHT,
  SET_CARGO_CONTENT,
  SET_CONSIGNEE,
  SET_COUNTRY_FROM,
  SET_COUNTRY_TO,
  SET_DRIVER_DOCUMENT_TYPE,
  SET_DRIVER_EXPIRATION_DATE,
  SET_DRIVER_DOCUMENT_ISSUED_COUNTRY,
  SET_DRIVER_DOCUMENT_NUMBER,
  CLEAR_RESERVATION,
  SET_DRIVER_INDEX,
  SET_USER_NOTE,
  SET_RESERVATION_CHANGE,
  SET_APP_STATE,
} from '../constants/actions'
import { Driver, ReservationChange } from '../types/reservation'

const initialState: ReservationChange = {
  resId: '',
  carLicencePlate: '',
  trailerRegCountry: '',
  trailerLicencePlate: '',
  cargoLength: '',
  cargoWeight: '',
  cargoContent: '',
  consignee: '',
  countryFrom: '',
  countryTo: '',
  drivers: [],
  driverIndex: 0,
  userNote: '',
  cargoType: '',
}

const reducer = (state: ReservationChange = initialState, action: any) => {
  const changeField = (field: string, value: string, driver: Driver) => {
    return { ...driver, [field]: value }
  }
  const returnNewDrivers = (drivers: Driver[], index: number, newDriver: Driver) =>
    drivers.map((item: Driver, i: number) => (i === index ? newDriver : item))
  switch (action.type) {
    case SET_RES_ID:
      return { ...state, resId: action.payload }
    case SET_DRIVER_FIRST_NAME: {
      const drivers = state.drivers
      const newDriver = changeField('firstName', action.payload, drivers[state.driverIndex])
      const newDrivers = returnNewDrivers(drivers, state.driverIndex, newDriver)
      return { ...state, drivers: newDrivers }
    }
    case SET_DRIVER_LAST_NAME: {
      const drivers = state.drivers
      const newDriver = changeField('lastName', action.payload, drivers[state.driverIndex])
      const newDrivers = returnNewDrivers(drivers, state.driverIndex, newDriver)
      return { ...state, drivers: newDrivers }
    }
    case SET_DRIVER_CITIZENSHIP: {
      const drivers = state.drivers
      const newDriver = changeField('citizenship', action.payload, drivers[state.driverIndex])
      const newDrivers = returnNewDrivers(drivers, state.driverIndex, newDriver)
      return { ...state, drivers: newDrivers }
    }
    case SET_DRIVER_BIRTH_DATE: {
      const drivers = state.drivers
      const newDriver = changeField('birthDate', action.payload, drivers[state.driverIndex])
      const newDrivers = returnNewDrivers(drivers, state.driverIndex, newDriver)
      return { ...state, drivers: newDrivers }
    }
    case SET_DRIVER_GENDER: {
      const drivers = state.drivers
      const newDriver = changeField('gender', action.payload, drivers[state.driverIndex])
      const newDrivers = returnNewDrivers(drivers, state.driverIndex, newDriver)
      return { ...state, drivers: newDrivers }
    }
    case SET_CAR_LICENCE_PLATE:
      return { ...state, carLicencePlate: action.payload }
    case SET_TRAILER_LICENCE_PLATE:
      return { ...state, trailerLicencePlate: action.payload }
    case SET_CARGO_LENGTH:
      return { ...state, cargoLength: action.payload }
    case SET_CARGO_WEIGHT:
      return { ...state, cargoWeight: action.payload }
    case SET_CONSIGNEE:
      return { ...state, consignee: action.payload }
    case SET_COUNTRY_FROM:
      return { ...state, countryFrom: action.payload }
    case SET_COUNTRY_TO:
      return { ...state, countryTo: action.payload }
    case SET_DRIVER_DOCUMENT_TYPE: {
      const drivers = state.drivers
      const newDriver = changeField('docType', action.payload, drivers[state.driverIndex])
      const newDrivers = returnNewDrivers(drivers, state.driverIndex, newDriver)
      return { ...state, drivers: newDrivers }
    }
    case SET_DRIVER_EXPIRATION_DATE: {
      const drivers = state.drivers
      const newDriver = changeField('docExpirationDate', action.payload, drivers[state.driverIndex])
      const newDrivers = returnNewDrivers(drivers, state.driverIndex, newDriver)
      return { ...state, drivers: newDrivers }
    }
    case SET_DRIVER_DOCUMENT_ISSUED_COUNTRY: {
      const drivers = state.drivers
      const newDriver = changeField('docIssuedCountry', action.payload, drivers[state.driverIndex])
      const newDrivers = returnNewDrivers(drivers, state.driverIndex, newDriver)
      return { ...state, drivers: newDrivers }
    }
    case SET_DRIVER_DOCUMENT_NUMBER: {
      const drivers = state.drivers
      const newDriver = changeField('docNumber', action.payload, drivers[state.driverIndex])
      const newDrivers = returnNewDrivers(drivers, state.driverIndex, newDriver)
      return { ...state, drivers: newDrivers }
    }
    case SET_CARGO_CONTENT:
      return { ...state, cargoContent: action.payload }
    case SET_DRIVER_INDEX:
      return { ...state, driverIndex: action.payload }
    case SET_RESERVATION_CHANGE:
      return {
        ...state,
        ...action.payload,
      }
    case CLEAR_RESERVATION:
      return { ...initialState }
    case SET_USER_NOTE:
      return { ...state, userNote: action.payload }
    case SET_APP_STATE:
      if (action.payload.reservationChange) {
        return { ...state, ...action.payload.reservationChange }
      }
    default:
      return state
  }
}

export default reducer
